import { useLocation, useSelector, shallowEqual, history } from 'umi';
import React, { useMemo, } from 'react';
import { baseNavListConfig } from '@/pages/home/components/NavHeader/_config';
import NoPermission from '@/pages/dashboard/components/NoPermission';
import { isAIGalleryAllowed } from '@/pages/home/_config/aigallery';

export default (props: { children: JSX.Element; }) => {
  const location = useLocation();
  const { userInfo } = useSelector(state => {
    // @ts-ignore
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  }, shallowEqual);

  const hasNoPermission = useMemo(() => {
    if (!userInfo) {
      return false;
    }
    const permissions = Object.keys(userInfo?.permissions || {});
    const allowAIGallery = isAIGalleryAllowed(userInfo?.openid);
    const curSys = Object.keys(baseNavListConfig).find((val) => location.pathname.startsWith(baseNavListConfig[val].sys));
    if (curSys) {
      const { rbac = '' } = baseNavListConfig[curSys];
      const findPermission = permissions.find(val =>
        val === rbac ||
        val === `${rbac}_pc` ||
        (val === 'aigc' && rbac === 'aigctool') ||
        ((val === 'aigc' || val === 'aigc_pc') && rbac === 'aigallery') ||
        rbac === 'studio' ||
        rbac === 'gamewiki'
      );
      // aigallery 灰度白名单：未命中视为无权限
      const blockedByAIGalleryWhitelist = rbac === 'aigallery' && !allowAIGallery;
      if (!findPermission || blockedByAIGalleryWhitelist) {
        // 【【管理端+PC经分+Datalab】权限组控制用户界面菜单显示隐藏】https://tapd.tencent.com/tapd_fe/20427644/story/detail/1120427644124421604
        // 访问databrain.intlgame.com，提示没有权限,跳转到第一个有权限的子系统
        const firstAuthorizedSystem = Object.values(baseNavListConfig || {})?.find(config => {
          const { rbac = '' } = config;
          // aigallery 不在白名单时，跳过，避免回弹到 /aigallery 形成无限重定向
          if (rbac === 'aigallery' && !allowAIGallery) {
            return false;
          }
          return permissions?.some(permission =>
            permission === rbac ||
            permission === `${rbac}_pc` ||
            (permission === 'aigc' && rbac === 'aigctool') ||
            ((permission === 'aigc' || permission === 'aigc_pc') && rbac === 'aigallery') ||
            rbac === 'studio' ||
            rbac === 'gamewiki'
          );
        });
        if (firstAuthorizedSystem?.sys) {
          history.push(firstAuthorizedSystem?.sys);
          // fix: 防止显示无权限页面再跳转，如果有子系统权限则不展示无权限页面
          return false;
        }
        // 没有权限访问任何子系统
        return true;
      }
    }
    return false;
  }, [userInfo, location.pathname]);

  return <>
    {
      hasNoPermission ?
        <NoPermission
          text={'You have no permission to access this page, please contact ivyyfchen to add permission'}
          textCN={'您暂无权限访问该页面,请联系ivyyfchen添加权限'}
        /> :
        props.children
    }
  </>;
};
